import { render } from "./ContenidoHome.vue?vue&type=template&id=6d54fa94"
import script from "./ContenidoHome.vue?vue&type=script&lang=js"
export * from "./ContenidoHome.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/congreso_online/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__